<template>
  <div class="tweetlist index__conteiner text-center">
    <not-found v-if="NotFound"></not-found>
    <div v-else>
     <v-card
     v-if="generatedTweet"
     class="mx-auto"
     color="#FFFFFF"
     width="100%"
     >
     <v-card-title
     class="amber darken-2 title__displayname"
     dark
     >
       <span class="font-weight">
         {{ screen_name }} bot のツイート
       </span>
     </v-card-title>
     <v-card-text class="headline font-weight-bold text__description">
        {{ generatedTweet }}
     </v-card-text>
     <v-card-actions>
       <v-list-item class="grow">
         <v-list-item-avatar color="grey darken-3">
         <v-img
         v-if="userinfo"
         class="elevation-6"
         :src="userinfo.photoURL"
         ></v-img>
         </v-list-item-avatar>
         <v-row
         align="center"
         justify="end"
         >
      <div class="checkbox__tweetgenerate">
        <input
          type="checkbox"
          id="ishashtag"
          v-model="ishashtag"
        >
        <strong><label for="ishashtag">ハッシュタグを付けない</label></strong>
        </div>
         <v-btn
         class="light-blue darken-1 text-center white--text"
         @click.prevent="PostingTweet"
         :disabled="processing"
         :loading="processing"
         >
           <font-awesome-icon :icon="['fab', 'twitter']"></font-awesome-icon>
           結果をツイートする
         </v-btn>
         </v-row>
       </v-list-item>
     </v-card-actions>
     </v-card>
     <v-btn
     class="amber darken-2 tweetgenerate__btn"
     dark
     @click.prevent="TweetGenerate"
     :disabled="processing"
     :loading="processing"
     :block=true
     >ツイート生成する</v-btn>
     <div class="checkbox__tweetgenerate">
      <input
        type="checkbox"
        id="checkbox"
        v-model="checkbox"
      >
      <label for="checkbox">みんなのついじぇね欄に表示させない</label>
      </div>
    </div>
  </div>
</template>

<script>
// import UserProfile from './UserProfile'
import axios from 'axios'
import NotFound from './pages/NotFound'
import CONSTANT from '../components/constants/index'
import firestore from '../plugins/firebase'
import firebase from 'firebase'

export default {
  name: 'GenerateTweetButton',
  components: {
    // 'user-profile': UserProfile,
    'not-found': NotFound
  },
  data () {
    return {
      generatedTweet: null,
      NotFound: false,
      processing: false,
      tweetUrl: '',
      tweetText: '',
      checkbox: false,
      ishashtag: false
    }
  },
  props: {
    screen_name: {
      type: String,
      default: null
    }
  },
  // pathの:idを直接書き換えた時の対応
  beforeRouteUpdate (to, from, next) {
    // 動的セグメントが変わった場合は、コールバック関数でtargetIdを更新する
    this.screen_name = to.params.screen_name
    next()
  },
  methods: {
    PostingTweet (btn) {
      if (this.processing) return
      this.processing = true
      if (this.$store.getters['auth/user']) {
        var userinfo = this.$store.getters['auth/user']
      } else {
        var userinfo = {
          'screenName': '',
          'displayName': '',
          'photoURL': ''
        }
      }
      // DBに登録する
      const UsersTweets = firestore.collection('UsersTweets')
      const payload = {
            'account': userinfo.screenName,
            'generated_account': this.screen_name,
            'display_name':userinfo.displayName,
            'photo_url': userinfo.photoURL,
            'generated_text': this.generatedTweet,
            'created_at': this.$moment(new Date()).format("YYYY/MM/DD HH:mm:ss"),
            'checkbox': this.checkbox
      }
      console.log(payload)
      UsersTweets.add(payload)
      .then((docRef) => {
          console.log("Document written with ID: ", docRef.id);
      })
      .catch((error) => {
          console.error("Error adding document: ", error);
      });
      this.TweetPost()
      // slackに通知
      axios.post(
        CONSTANT.SLACK_TWEET,
        JSON.stringify({
          text: this.generatedTweet,
          username: this.screen_name
        }),
        {
        withCredentials: false,
        transformRequest: [(data, headers) => {
          delete headers.common.Authorization
          delete headers.post["Content-Type"]
          return data
        }]
      }).catch(err => {
          console.log("error: ", err)
          return
        })
    },
    createTweetUrl () {
      // Twitter用のurl作成
      const url = encodeURIComponent(location.href)
      const hashTags = encodeURI('ついじぇね,自分bot')
      const generatedText = encodeURI(this.generatedTweet + '\n\n')
      // ハッシュタグを付けないにチェックボックスが入っていたら、ハッシュタグを付けない
      if (this.ishashtag == true) {
        this.tweetUrl = 'https://twitter.com/intent/tweet?text=' + generatedText + '&url=' + url
      } else {
        this.tweetUrl = 'https://twitter.com/intent/tweet?text=' + generatedText + "%23ついじぇね%20%23自分bot%0A" + '&url=' + url
      }
      return this.tweetUrl
    },
    TweetGenerate (btn) {
      if (this.processing) return
      this.processing = true
      // POST送信する
      axios.post(
        CONSTANT.GENERATE_URL,
        {
          account: this.screen_name
        }
      )
      // 送信完了
        .then((res) => {
          this.generatedTweet = res.data
          this.processing = false
        })
        .catch(error => {
          this.processing = false
          this.generatedTweet = 'ツイート生成に失敗しました。もう一度試してみてください'
          axios.post(
            CONSTANT.SLACK_SERVER_ERROR,
            JSON.stringify({
              text: this.generatedTweet + "\n" + error + "\n" + res.data,
              username: this.screen_name
            }), {
              withCredentials: false,
              transformRequest: [(data, headers) => {
                delete headers.common.Authorization
                delete headers.post["Content-Type"]
                return data
              }]
              }).then( res => {
              window.location.reload()
          }).catch(err => {
            console.log("error: ", err)
          })
        })
    },
    TweetPost () {
      if (!this.processing) {return}
      this.processing = true
      const userinfo = this.$store.getters['auth/user']
      const tweetPage = this.createTweetUrl()
      if (!window.open(tweetPage)) {
        window.location.href = tweetPage
      } else {
        window.open(tweetPage)
      }
      this.processing = false
    },
    isTrueURL () {
      const userurl = this.$store.getters['auth/user']
      if (userurl) {
        if (userurl.screenName === this.$route.params.screen_name) {
          this.NotFound = false
        } else {
          this.NotFound = true
        }
      } else {
        this.$router.push('/')
      }
    }
  },
  // ゲッター
  computed: {
    isLogin () {
      return this.$store.getters['auth/check']
    },
    userinfo () {
      return this.$store.getters['auth/user']
    }
  }
}
</script>
<style>
.tweetlist {
  margin: auto;
  display: grid;
  width: 100%;
  height: fit-content;
}

.row__test__delete {
  margin: auto;
}

.index__description {
  /* font-size: small; */
  /* padding: 10px; */
}

.twitter__displayname {
  width: 50px;
}

.title__displayname {
  font-size: 1rem;
  color: #ffffff;
}

.text__description {
  padding-top: 16px !important;
}
.checkbox__tweetgenerate {
  font-size: 16px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/GenerateTweetButton.vue